import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudService, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { RANGER_FIREARM_ASSIGNMENT_LOG_TYPE, RangerFirearmAssignmentLog } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class RangerFirearmAssignmentLogServiceBase extends CrudService<RangerFirearmAssignmentLog, number> {

  servicePath: string = '/rangerfirearmassignmentlog';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, RANGER_FIREARM_ASSIGNMENT_LOG_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, reduced: boolean = true): Observable<HateoasMultipleResponseObject<RangerFirearmAssignmentLog>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<RangerFirearmAssignmentLog>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



